exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-shelf{background-size:cover}.empty-shelf__fade{align-items:center;background-color:rgba(255,255,255,0.5);display:flex;flex-direction:column;font-size:16px;font-size:1rem;height:100%;justify-content:center}.empty-shelf__body{background-color:rgba(51,51,51,0.9);border-radius:3px;color:#fff;padding:15px 30px;text-align:center}\n", ""]);

// exports
exports.locals = {
	"empty-shelf": "empty-shelf",
	"empty-shelf__fade": "empty-shelf__fade",
	"empty-shelf__body": "empty-shelf__body"
};